var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ul',_vm._l((_vm.newsFeed),function(news){return _c('li',{key:news.id},[_c('a',{staticClass:"news-title",attrs:{"href":_vm.newsUrl(news),"target":"_blank"}},[_vm._v(_vm._s(_vm.newsTitle(news)))]),_c('div',{staticClass:"news-summary"},[_vm._v(_vm._s(_vm.newsSummary(news)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }